import { Loader } from "@circle-react-uikit/Loader";
import { ChatItem } from "@circle-react/components/Modals/MessagingModalCompass/LeftSidebar/List/BotChat/ChatItem";
import { useChatList } from "@circle-react/components/SettingsApp/CommunityInbox/hooks/useCommunityChatList";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useMessagingPaths } from "@circle-react/hooks/chatsV2/messaging/useMessagingPaths";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";
import InfiniteScroll from "react-infinite-scroll-component";

import { useMobileFullBleedContent } from "@/react/components/Mobile/hooks/chrome/useMobileFullBleedContent";

import { EmptyState } from "./EmptyState";
import { EmptyStateForRightActionBlock } from "./EmptyStateForRightActionBlock";

export const BotChatList = ({
  isRightActionBlock,
  isRenderedOnHeader,
}: {
  isRightActionBlock?: boolean;
  isRenderedOnHeader?: boolean;
}) => {
  const {
    isChatsLoading: isBotChatsLoading,
    hasNextPage,
    fetchNextPage,
  } = useChatList({
    filter: "mine",
  });
  const { currentChatId, memberChats: chats } = useCommunityInboxStore();
  const { chatBotPath } = useMessagingPaths();
  const bleedContent = useMobileFullBleedContent();

  if (isBotChatsLoading) {
    return <Loader center />;
  }
  if (chats.length === 0) {
    if (isRightActionBlock) {
      return <EmptyStateForRightActionBlock />;
    }
    return <EmptyState />;
  }

  return (
    <>
      {bleedContent}
      <InfiniteScroll
        scrollThreshold={0.8}
        next={fetchNextPage}
        hasMore={Boolean(hasNextPage)}
        dataLength={chats.length}
        scrollableTarget="scrollable-dms-div"
        className="mt-2 flex h-full flex-col gap-y-0.5 overflow-auto"
        loader={<Loader center />}
      >
        {chats.map((chat: Chat) => {
          const isOpenChatRoom = chat.id == currentChatId;

          return (
            <ChatItem
              key={chat.id}
              chat={chat}
              path={chatBotPath({ id: chat.id.toString() })}
              isUnread={!isOpenChatRoom && chat.has_unread_messages_for_member}
              isBotType
              className={classNames({
                "dark:hover:bg-secondary": isRightActionBlock,
                "dark:!bg-primary dark:hover:!bg-secondary": isRenderedOnHeader,
              })}
            />
          );
        })}
      </InfiniteScroll>
    </>
  );
};
